module.exports = __webpack_public_path__ + "frontend/img/icon-home-xs.94ecba30.svg";